import React from 'react'

interface Props {
  location: string
}

const Map: React.SFC<Props> = ({ location }) => {
  if (!location) {
    return null
  }

  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBn0mYOUPbZSukBIBjPvTmXyNzzwOS5glA&q=${location}`

  return <iframe width="100%" height="100%" frameBorder="0" src={mapUrl} allowFullScreen={true} />
}

export default Map
